<template>
  <v-app>
    <v-content :class="{'banner': this.$router.currentRoute.path=='/'}">
      <v-row justify="center" no-gutters v-if="this.$router.currentRoute.path!='/'">
        <v-col cols="12">
          <v-img
          :src="topBanner"
          contain
          >
          <!-- v-img
            :src="logoImg"
            contain
            class="logo-img"
            max-height="118"
            min-height="40"
          ></!-->
          </v-img>
        </v-col>
        <!-- v-col cols="12"  **v-show="$vuetify.breakpoint.mdAndUp"** v-show="$vuetify.breakpoint.smAndDown">
          <v-img
          :src="topBannerMobile"
          contain
          >
          <v-img
            :src="logoImg"
            contain
            class="logo-img"
            max-height="118"
            min-height="50"
            :class="{'small-logo': $vuetify.breakpoint.mdAndDown}"
          ></v-img>
          </v-img>
        </v-col -->
      </v-row>
      <v-row justify="center" no-gutters class="subheader" v-if="this.$router.currentRoute.path!='/'">
        <v-col cols="12">
          <h1>{{subtitle}}</h1>
        </v-col>
      </v-row>
      <v-row justify="center" no-gutters class="main-page" :class="{'form-container' : this.$router.currentRoute.path=='/form', 'thanks-container' : this.$router.currentRoute.path=='/thanks'||this.$router.currentRoute.path=='/soon'||this.$router.currentRoute.path=='/sorry'}">
        <v-col cols="12">
          <router-view 
              v-bind:site-data="siteData"
              v-bind:lang-data="langData" 
              v-bind:stage="stage"
              v-bind:country="country" 
              @stage-changed="updateStage($event)"
            ></router-view>
        </v-col>
      </v-row>
    </v-content>
    <v-footer 
      padless
      v-if="this.$router.currentRoute.path!='/'"
      :class="{'footer-nl' : nlFooter}"
      >
    </v-footer>
  </v-app>
</template>

<script>
//import siteData from "./site-data"
import siteData from "./data/content.json"
import Early from './components/Early'
import Late from './components/Late'

export default {
  name: 'App',
  components: {
    Early,
    Late
  },
  beforeCreate() {
    var url = window.location.origin
    this.axios.get('/api/getSiteStatus').then((response)=>{
      console.log(response)
      if(response.data.success) {
        switch(response.data.payload.stateCode) {
          case 1:
            // early
          break;
          case 3:
            // late
              this.currentComponent = 'Late';
              this.$router.push('/sorry')
          break;
          case 5:
            // dev
            this.currentComponent = 'Early'; 
          // password protection
          break;
        }
      }else {
        
      }
    })
  },
  created() {
    if(this.$router.currentRoute.path!='/') {
      this.stage = 1
    }else{
      this.stage = 0
    }
    /*if(navigator.language == 'en-GB') {
      this.langData = this.siteData.en
    }else{
      this.topBanner = {src:require('@/assets/TopBannerNl.png')}
      this.langData = this.siteData.nl
      this.nlFooter = true
    }*/
    console.log(window.location.origin)
    if(navigator.language == 'nl') {
      this.topBanner = {src:require('@/assets/TopBannerNl.png')}
      this.langData = this.siteData.nl
      this.nlFooter = true
      this.logoImg = require('./assets/LogoNl.png')
      this.country = 'nl'
    }else{
      this.langData = this.siteData.en
    }
    if(window.location.origin == 'https://arlanl.promonow.io' || window.location.origin == 'https://staging.arlanl.promonow.io') {
      this.topBanner = {src:require('@/assets/TopBannerNl.png')}
      this.langData = this.siteData.nl
      this.nlFooter = true
      this.logoImg = require('./assets/LogoNl.png')
      this.country = 'nl'
    }else{
      this.langData = this.siteData.en
    }
    this.subtitle = this.langData.sitewide.bannerText
  },
  data: (el=this) => ({
    siteData: siteData,
    langData: [],
    stage: 0,
    topBanner : {src:require('@/assets/TopBanner.png')},
    topBannerMobile: {src:require('@/assets/TopBannerMobile.png')},
    logoImg: {src:require('@/assets/Logo.png')},
    bottomBanner : {src:require('@/assets/BottomBanner.png')},
    subtitle: '',
    heartsImage : {src:require('@/assets/HeartsImg.png')},
    nlFooter:false,
    currentComponent: '',
    country: 'en'
  }),
  methods: {
    updateStage: function(event) {
        this.stage = event
    },
  },
  watch:{
    $route (to, from){
      if (to.path!='/') {
        this.stage = 1
      }else{
        this.stage = 0
      }
    }
} 
};
</script>

<style>
@font-face {
  font-family: "Arla Interface";
  src: url('./assets/fonts/ArlaIF_Rg.eot'); /* IE9 Compat Modes */
  src: url('./assets/fonts/ArlaIF_Rg.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
        url('./assets/fonts/ArlaInterFace-Regular.woff') format('woff'), /* Modern Browsers */
        url("./assets/fonts/ArlaIF_Rg.ttf")  format('truetype'); /* Safari, Android, iOS */
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Arla Interface Bold";
  src: url('./assets/fonts/ArlaIF_Bd.eot'); /* IE9 Compat Modes */
  src: url('./assets/fonts/ArlaIF_Bd.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
        url('./assets/fonts/ArlaInterFace-Bold.woff') format('woff'), /* Modern Browsers */
        url("./assets/fonts/ArlaIF_Bd.ttf")  format('truetype'); /* Safari, Android, iOS */
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Arla Strong";
  src: url('./assets/fonts/ARLA STRONG/ARLASTRONG-Regular.eot'); /* IE9 Compat Modes */
  src: url('./assets/fonts/ARLA STRONG/ARLASTRONG-Regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
        url('./assets/fonts/ARLA STRONG/Web/ARLASTRONG-Regular.woff') format('woff'), /* Modern Browsers */
        url("./assets/fonts/ARLA STRONG/TTF/ARLASTRONG-Regular.ttf")  format('truetype'); /* Safari, Android, iOS */
  font-weight: normal;
  font-style: normal;
}
#app {
  background-color:#eae6e7;
}
.v-main.v-content:not(.banner) {
  background-color:#eae6e7;
  background-size: cover;
  background-position: bottom center;
}
.banner {
  background-color:#fff;
/* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+0,d5e2db+16,d5e2db+100&0+0,0.71+16,1+43,1+100 */
background: -moz-linear-gradient(left,  rgba(255,255,255,0) 0%, rgba(213,226,219,0.71) 16%, rgba(213,226,219,1) 43%, rgba(213,226,219,1) 100%); /* FF3.6-15 */
background: -webkit-linear-gradient(left,  rgba(255,255,255,0) 0%,rgba(213,226,219,0.71) 16%,rgba(213,226,219,1) 43%,rgba(213,226,219,1) 100%); /* Chrome10-25,Safari5.1-6 */
background: linear-gradient(to right,  rgba(255,255,255,0) 0%,rgba(213,226,219,0.71) 16%,rgba(213,226,219,1) 43%,rgba(213,226,219,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#d5e2db',GradientType=1 ); /* IE6-9 */
}
.v-dialog > .v-card .v-card__text.where-to-find,
.v-dialog > .v-card .v-card__text.where-to-find-nl {
  padding:8px 0px 0px 0px;
}
.row .padded {
  padding-top:8px;
  padding-bottom:8px;
}
.v-application {
  font-family: 'Arla Interface';
}
.v-btn {
  border-radius: 0 !important;
}
.subheader {
  background-color: #6c9778;
  color:#fff;
  padding-top:12px;
  padding-bottom:10px;
}
.subheader h1 {
  text-align: center;
  font-size: 0.9em;
  line-height:0.9em;
}
.subheader h1,
h1.arla-strong,
.arla-strong,
.v-card__title.arla-strong,
.v-expansion-panel-header {
  text-transform: uppercase;
  font-family: 'Arla Strong';
  font-weight:500;
  word-break: break-word;
}
.v-btn--fab.v-size--x-large .v-icon.mdi-camera {
  font-size: 46px;
}
.v-card__title .arla-strong,
.v-card {
  line-height: 21px;
}
h2 {
  font-family: 'Arla Interface Bold';
}
.rays-right {
  background-image: url('./assets/lashesRight.png');
  background-position: center left 8px;
  background-size: contain;
}
.rays-left {
  background-image: url('./assets/lashesLeft.png');
  background-position: center right 8px;
  background-size: contain;
}
.v-footer {
  border-top: 16px solid #e93e8f !important;
  background-image: url("./assets/BottomBanner.png");
  background-position: center;
  background-size: cover;
  height:225px;
}
.v-footer.footer-nl {
  background-image: url("./assets/BottomBannerNl.png");
}
.landing {
  background-image: url("./assets/BackgroundGradientRTL.png");
  background-position: center;
  background-size: cover;
}
.landing h1 {
  text-transform: uppercase;
}
.heartsRight > .v-image, .heartsLeft >.v-image {
  margin-top:84px;
}
.green-slant {
  transform: skew(-9deg, 0deg);
  background-color: #6c9778;
}
.heading-block h1.arla-strong {
  padding-right:18px;
  padding-left:18px;
  transform: skew(9deg, 0deg);
  line-height:1.1;
      padding-top: 6px;
    padding-bottom: 6px;
}
.v-expansion-panel-header {
  color:#6c9778;
  transform: skew(9deg, 0deg);
}
.v-expansion-panel-header.v-expansion-panel-header--active {
  transform: skew(-9deg, 0deg);
}
.v-expansion-panel {
  transform: skew(-9deg, 0deg);
  margin-bottom: 8px;
}
.v-expansion-panel-header--active .faq-headers {
  transform: skew(9deg, 0deg);
}
.v-expansion-panel.v-expansion-panel--active.panel-open {
  transform: none;
}
.v-expansion-panel-content__wrap .v-card .v-card__text {
  color:#6c9778;
  font-weight:600;
  font-size: 16px;
}
a {
  color:#000 !important;
  text-decoration: underline;
}
.text-pink, .v-btn {
  color:#e93e8f !important;
}
.text-green {
  color:#6c9778;
}
a.green-link {
  color:#6c9778 !important;
}
.text-white {
  color:#fff;
}
.center-text {
  text-align:center;
}
.white-col {
  background-color: #FFF !important;
}
.headline{
  background-color:#6c9778;
}
.padded-left {
  padding-left: 16px;
}
.margin-right-sm {
  margin-right: 8px;
}
.panel-open > button {
  background-color:#6c9778;
  color:#fff;
}
.margin-sm-right {
  margin-right:12px;
  margin-top:-4px;
}
.margin-sm-left {
  margin-left:8px;
  margin-top:-4px;
}
.heading-row {
  padding-top:18px;
  padding-bottom:16px;
}
.v-expansion-panel--active.panel-open .v-expansion-panel-content__wrap,
.theme--light.v-expansion-panels .v-expansion-panel.v-expansion-panel--active.panel-open {
  background-color: transparent;
}
.v-expansion-panel-content__wrap {
  padding: 0 9px 0 0px;
}
.theme--light.v-sheet--outlined {
  border:none;
}
.tighten-leading {
  line-height:1.2;
}
.annoying {
    width:100%;
    text-align:left;
    padding-left:88px;
    display:inline-block;
    line-height: 20px;
    font-size:20px;
    
  }
  .small-heading {
    font-size:1.2em;
  }
  .small-modal .text-green.mid-size.padded-left {
    margin-top:120px;
  }
 
  .v-btn--fab.v-size--x-large.upload-button.small-upload {
    width:70px;
    height: 83px;
  }
  .v-btn--fab.v-size--x-large.upload-button.small-upload .button-text {
    top:11px;
    font-size:0.9em;
  }
  .v-application .v-dialog > .v-card > .v-card__title.headline .col {
    font-size:1.4rem;
  }
  .v-application .headline.small-heading-modal {
    font-size:1em !important;
  }
  .hover:hover {
    cursor: pointer;
  }
   .logo-img {
    height:60px;
    top:8px;
    left:0px;
    float:left;
  }
  
  .jog-down {
    margin-top:0px;
  }
  .terms-label>span {
    line-height: 20px;
    font-size: 20px;
  }
  .terms-label {
    padding-top:37px;
    padding-left:16px;
  }
  .capcha[error="true"] {
    border:1px solid #ff5252;
  }
  /* FILE UPLOADS */
  .fileUploadFront,.fileUploadBack {
    display: none;
  }
  .button-text {
    position: absolute;
    top: 15px;
    text-transform: capitalize;
    color: #000;
    letter-spacing: normal;
  }
  .v-btn--fab.v-size--x-large.upload-button {
    height: 94px;
    width: 79px;
  }
  .v-btn--fab.v-size--x-large.upload-button .v-icon {
    margin-top: -32px;
  }
/* OVERRIDES */
.v-textarea.v-text-field .v-label {
    overflow: visible;
    overflow-wrap: anywhere;
    white-space: break-spaces;
}
.v-textarea.v-text-field--enclosed textarea {
  margin-top:38px;
}
h2.upload-title {
  /*margin-left:-6px;*/
  font-size:22px;
  margin-bottom: 4px;
}
.code-title {
  margin-bottom:8px;
}
.padded-top {
  top: 22px;
}
.padded-top-sm {
  top: 12px;
}
.upload-button .v-btn--icon.v-size--x-large .v-icon, .v-btn--fab.v-size--x-large .v-icon {
  height: 52px;
  font-size: 52px;
  width: 52px;
}
.rays:hover:before,
.rays:hover:after {
  content:'';
  width:22px;
  height:36px;
  background-image:url('./assets/lashesLeftPink.png');
  background-size: contain;
  position:absolute;
}
.rays:hover:before {
  margin-left:-21px;
}
.rays:hover:after {
  display:inline-block;
  margin-bottom: -14px;
  margin-left:6px;
  margin-right:-6px;
  background-image:url('./assets/lashesRightPink.png');
}
.rays.file:hover:before {
  margin-left:-22px;
  position:absolute;
}
.rays.file:hover:after {
  position:absolute;
}
.v-text-field__details:not(.manual-error) {
    position: absolute;
    top: -16px;
    width: 100%;
  }
  .manual-error:not(.captcha-error, .batch-code-error) {
    margin-top: -76px;
    margin-bottom: 76px;
  }
  .manual-error.upload {
    margin-top: -76px;
    margin-bottom: 76px;
  }
  .captcha-error {
    margin-top: -96px;
    margin-bottom: 96px;
  }
  .error-right.error--text .v-text-field__details{
    display: inline;
  }
  .error-right.error--text .v-input__slot{
    display: inline;
  }
  .v-input.error--text .v-text-field__slot {
    background-image:url('./assets/error-24px.svg');
    background-position: center right;
    background-size:27px;
    transform: skew(9deg, 0deg);
    fill:#6c9778;
  }
  .v-textarea.error--text .v-text-field__slot {
    background-position: center right 8px;
  }
  .batch-code-error {
    padding-top:61px;
  }
.v-application .error .v-icon {
  color:#fff !important;
}
.v-application .error .button-text {
  color:#fff !important;
}
.v-dialog .v-card.hide-background, 
.v-dialog .v-card.hide-background .v-card__text {
  padding:0;
}
.scale-up {
  transform: scale(1.8);
  transform-origin: left;
  margin-top:-20px;
  max-width:100px;
}
.scale-up .v-messages__message {
  transform: scale(0.6);
}
.scale-up .v-messages.theme--light.error--text {
  width: 300%;
  margin-left: -48%;
}
.scale-up.scale-up-sm {
  max-width:50px;
  margin-top: -38px;
}
.v-btn--outlined {
    border: 3px solid currentColor;
    font-family: 'Arla Interface Bold'
}
.v-btn.submit-button.v-size--default {
  padding: 0 30px;
}
.theme--light.v-btn:hover::before {
  opacity: 1;
}
.theme--light.v-btn:hover .v-btn__content {
  color:#fff;
}
.theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
    background: #f9f9f9 !important;
    transform: skew(-9deg, 0deg);
}
.v-dialog {
    border-radius: 16px !important;
}

    
/* RESPONSIVE */
  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) { 
    .logo-img {
      height:84px;
      top:8px;
      left:0px;
    }
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) { 
    .v-textarea.v-text-field--enclosed textarea {
      margin-top:24px;
    }
    .terms-label {
      padding-left:auto;
    }
    .subheader h1 {
      font-size:2em;
      line-height: 2em;
    }
    .subheader {
      padding-top:32px;
      padding-bottom:34px;
    }
    .v-btn--fab.v-size--x-large .v-icon.mdi-camera {
      font-size: 52px;
    }
    .arla-strong,
    .heading-block h1.arla-strong {
      line-height:1.5;
      padding-top: 0;
      padding-bottom: 0;
    }
    .lg-size {
      font-size:20px;
    }
    .mid-size{
      font-size:16px;
    }
    .logo-img {
      height:98px;
      top:8px;
      left:0px;
    }
  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) {
    .v-btn--fab.v-size--x-large.upload-button.small-upload .button-text {
      font-size:1em;
    }
    .form-container {
      background-image: 
        url('./assets/Heart Icon.svg'),
        url('./assets/Heart Icon.svg'),
        url('./assets/Heart Icon.svg'),
        url('./assets/Heart Icon.svg'),
        url('./assets/Heart Icon.svg'),
        url('./assets/Heart Icon Back.svg'),
        url('./assets/Heart Icon Back.svg'),
        url('./assets/Heart Icon Back.svg'),
        url('./assets/Heart Icon Back.svg');
      background-size: 
        76px, 105px, 154px, 76px, 105px, 120px, 66px, 95px, 154px;
      background-position:
        /*top 100px right 20px, 
        top 176px right 55px, 
        top 42% right 20px,
        bottom 423px right 20px, 
        bottom 316px right 55px,
        top 136px left 20px, 
        top 623px left 20px, 
        top 710px left 55px, 
        bottom 275px left 20px;*/
        top 100px right 90px, 
        top 176px right 125px, 
        top 42% right 90px,
        bottom 423px right 90px, 
        bottom 316px right 125px,
        top 136px left 90px, 
        top 623px left 90px, 
        top 710px left 125px, 
        bottom 275px left 90px;
        
      background-repeat:
        no-repeat;
    }
    .thanks-container {
      background-image: 
        url('./assets/Heart Icon.svg'),
        url('./assets/Heart Icon.svg'),
        url('./assets/Heart Icon Back.svg');
      background-size: 
        76px, 105px, 120px;
      background-position:
        top 38px right 90px, 
        top 105px right 125px, 
        top 68px left 90px;
        
      background-repeat:
        no-repeat;
    }
    .logo-img {
      height:100%;
      top:8px;
      left:8px;
    }
  }

  @media (min-width: 960px) and (max-width: 1200px) {
    
  }

  /* Extra large devices (large desktops, 1200px and up)*/
  @media (min-width: 1200px) {
    
  }
  /* Extra large devices (large desktops, 1200px and up)*/
  @media (min-width: 1500px) {
    
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /* IE10+ CSS styles go here */
    .button-text {
      margin-left:-70%;
    }
    :not(.v-btn--round).v-btn.v-size--default {
      padding: 0 8px;
    }
    .scale-up {
      max-width:48px;
    }
  }
</style>
